import moment from 'moment';
import { message } from 'antd';
import { version } from '../config';

window.onload = function(){
    var last_slide_index = location.pathname.lastIndexOf('/');
    var _version = location.pathname.slice(last_slide_index+1);
    if(location.pathname != '/'){
        if(version !== _version ){
            sessionStorage.clear();
            localStorage.clear();
            window.location.replace('/');
            getUser();
        }
    }
    var url=document.location.href;  //获取浏览器访问栏里的地址 
    var lastStr = url.slice(url.length-1);
    if(lastStr == '/'){
        if( url.indexOf("r=")==-1 ){    //判断地址后面是否多了某些值，没有就进方法里进行刷新
            var t = new Date();
            window.location.href = url+"?r="+t.getTime();
        }
    }
}

// 获取用户信息
export function getUser(notRedirect = false) {
    function reLogin() {
        if (location.pathname != `/register/${version}` && location.pathname != `/`) {
            message.error('请重新登录');
            location.href = `/`;
            return false;
        }
    }
    let userStr = sessionStorage.getItem(`user_info`);
    let user = null;
    if (userStr == null) {
        reLogin();
        // return null;
        return user = [];
    }
    try {
        user = JSON.parse(userStr);
    } catch (e) {
        reLogin();
        return null;
    }
    if (!user.now) {
        reLogin();
        return null;
    }
    return user;
}

// 清除用户信息
export function clearUser() {
    sessionStorage.removeItem(`user_info`);
    localStorage.removeItem(`user_info`);
}

// 保存token
export function saveUser(obj) {
    const now = moment().unix();
    const objJson = JSON.stringify({ ...obj, now });
    sessionStorage.setItem(`user_info`, objJson);
}

// 整理错误
export function createChecks(checks) {
    return {
        check(key, value, obj) {
            return checks[key](value, obj);
        },
        checkAll(obj) {
            const result = {
                hasError: false,
                errors: {}
            };
            Object.keys(obj).forEach((key) => {
                const error = checks[key](obj[key], obj);
                if (error) {
                    result.hasError = true;
                    result.errors[key] = error;
                }
            });
            return result;
        }
    }
}

// 检测时间范围并整理 一个月间隔
export function formatDate([startStr, endStr], no_time=false) {
    const start = startStr ? moment(startStr) : null;
    let end = endStr ? moment(endStr) : null;
    if (start && end) {
        if (start.month() != end.month()) {
            end = start.clone();
            if (no_time) {
              return [startStr, end.format('YYYY-MM-DD')]
            }
            return [startStr, end.format('YYYY-MM-DD 23:59:59')]
        } else {
            return [startStr, endStr];
        }
    } else {
        return [startStr, endStr];
    }
}


// 将对象编译成为查询字符串
export function makeQuery(params) {
    const searchArr = [];
    Object.keys(params).forEach(key => {
        searchArr.push(`${key}=${encodeURIComponent(params[key])}`);
    });
    if (searchArr.length > 0) {
        return `?${searchArr.join('&')}`;
    }
    return '';
}

export function dateToStr (dt ,type){
  var datetime = new Date(dt);
  var year = datetime.getFullYear();
  var month = datetime.getMonth()+1;//js从0开始取
  var date = datetime.getDate();
  var hour = datetime.getHours();
  var minutes = datetime.getMinutes();
  var second = datetime.getSeconds();

  if(month<10){
      month = "0" + month;
  }
  if(date<10){
      date = "0" + date;
  }
  if(hour <10){
      hour = "0" + hour;
  }
  if(minutes <10){
      minutes = "0" + minutes;
  }
  if(second <10){
      second = "0" + second ;
  }

  var time = year+"-"+month+"-"+date+" "+hour+":"+minutes+":"+second; //2009-06-12 17:18:05
  var _time = year+"-"+month+"-"+date; //2009-06-12
  return type ? _time : time;
}

export function toDate(dt){
  var datetime = new Date(dt);
  var year = datetime.getFullYear();
  var month = datetime.getMonth()+1;//js从0开始取
  var date = datetime.getDate();
  var hour = datetime.getHours();
  var minutes = datetime.getMinutes();
  var second = datetime.getSeconds();

  if(month<10){
      month = "0" + month;
  }
  if(date<10){
      date = "0" + date;
  }
  if(hour <10){
      hour = "0" + hour;
  }
  if(minutes <10){
      minutes = "0" + minutes;
  }
  if(second <10){
      second = "0" + second ;
  }

  var time = year+""+month+""+date; //2009-06-12 17:18:05
  return time;
}

export function toYuan(fen,intType){
    if(!fen){
        return 0;
    }
    var yuan;
    if(intType == 'int'){
        yuan = (parseFloat(fen)/100).toFixed(2);
    }else{
        yuan = (parseFloat(fen)/100).toFixed(2);
    }
    return yuan;
}

export function listWithKey(par){
    let list = [];
    par.map((item,idx)=>{
        item.key = idx;
        list.push(item);
    });
    return list;
}

export function arrayDiff(newArr, oldArr) {
    if (newArr.length < oldArr.length) {
        return oldArr.filter(function (i) { return newArr.indexOf(i) < 0; });
    } else {
        return newArr.filter(function (i) { return oldArr.indexOf(i) < 0; });
    }

}


// WEBPACK FOOTER //
// ./src/utils/util.js